/*eslint no-unused-vars: ["error", { "args": "none" }]*/
export default {
    install(app) {
        app.config.globalProperties.ucwords = (str) => {
            return (' '+str).replace(/ [\w]/g, a => a.toLocaleUpperCase()).trim();
        }
    }
};